import React, {useEffect, useState} from 'react';
import { Container } from 'react-bootstrap';



// // style={{width:"100%" ,height:"100%"}}

function Herosection() {

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    
      useEffect(() => {
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

 


  return (
    <Container 
    fluid 
   className="container-section"
    style={{backgroundColor: "#EEEDEB",
      display: "flex",
      alignItems: "center", 
      justifyContent: "center", 
      height: isSmallScreen ? "50vh" : "100vh",}}>

<svg style={{width:"50%" ,height:"50%"}} viewBox="0 0 4295 2070" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2163.27 750.775V1358.71H2392.23L2881.74 513.916L3726.54 1942.97H4295L3181.76 0.720947H2605.4L2163.27 750.775Z" fill="#222222"/>
<path d="M1579.06 884.996L1594.85 1935.07H3363.4L2889.68 1113.96L2715.99 1477.14H2068.57V900.786C2068.57 403.694 1665.6 0.720947 1168.51 0.720947H963.228C431.252 0.720947 0 431.973 0 963.949V1106.06C0 1638.04 431.252 2069.29 963.228 2069.29H1492.21V1358.71L1235.87 1496.75C1201.69 1515.15 1164.89 1528.19 1126.75 1535.4C853.211 1587.15 600.044 1377.39 600.044 1099V876.943C600.044 676.976 754.841 511.136 954.334 497.378L1085.92 488.303C1328.64 471.563 1543.41 644.326 1579.06 884.996Z" fill="#222222"/>
<ellipse cx="1073.82" cy="1003.43" rx="363.184" ry="371.08" fill="#222222"/>
</svg>

  </Container>
  )
}

export default Herosection;
